import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _Getters;

import * as types from "@/store/constants/types";
import { getBatch } from '@/utils/numUtils';
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_SETTING_DATA, function (state, payLoad) {
  return state.settingData;
}), _defineProperty(_Getters, types.GETTER_MAIN_FUNCTION_LIST, function (state) {
  var launchConfig = state.launchConfig;
  var source = launchConfig && launchConfig.af_install_data && launchConfig.af_install_data.media_source;
  var clentData = state.settingData && state.settingData.client;
  var map = {
    "snapchat_int": "snapchat",
    "Facebook Ads": "facebook",
    "Organic": "organic"
  };
  var name = "main_function_list";
  var key = source && map[source] ? map[source] + "_" + name : name;
  console.log("GETTER_MAIN_FUNCTION_LIST key", key);
  return clentData && clentData[key] ? clentData[key] : clentData[name];
}), _defineProperty(_Getters, types.GETTER_OFFER_MAP, function (state) {
  return state.settingData && state.settingData.common && state.settingData.common.offer_map;
}), _defineProperty(_Getters, types.GETTER_PRICE_MAP, function (state) {
  return state.settingData && state.settingData.common && state.settingData.common.price_map;
}), _defineProperty(_Getters, types.GETTER_VIP_OFFER_LIST, function (state) {
  return state.settingData && state.settingData.client && state.settingData.client.vip_offer_list;
}), _defineProperty(_Getters, types.GETTER_MORNING_NOOTICE_STATUS, function (state) {
  return state.isShowMoringNotification;
}), _defineProperty(_Getters, types.GETTER_EVNING_NOOTICE_STATUS, function (state) {
  return state.isShowEveningNotification;
}), _defineProperty(_Getters, types.GETTER_LAUNCH_CONFIG, function (state) {
  return state.launchConfig;
}), _defineProperty(_Getters, types.GETTER_OFFER_ID, function (state) {
  return state.offer_id;
}), _defineProperty(_Getters, types.GETTER_DELAY_SINGLE_PAGE_TIME, function (state) {
  var delay_show_single_vip = state.settingData && state.settingData.client && state.settingData.client.vip_config && state.settingData.client.vip_config.delay_show_single_vip;
  return delay_show_single_vip ? getBatch(1500, 2000) : 0;
}), _defineProperty(_Getters, types.GETTER_VIP_PLAN_BY_SOURCE, function (state) {
  var launchConfig = state.launchConfig;
  var source = launchConfig && launchConfig.af_install_data && launchConfig.af_install_data.media_source;
  var result = launchConfig && launchConfig.vip_center_welcome_page;
  var map = {
    "snapchat_int": "snapchat_vip_config",
    "Facebook Ads": "facebook_vip_config",
    "Organic": "organic_vip_config"
  };

  if (source) {
    var key = map[source];
    result = launchConfig[key] ? launchConfig[key].vip_center_welcome_page : result;
  }

  console.log("GETTER_VIP_PLAN_BY_SOURCE result", result);
  return result;
}), _Getters);
export default Getters;